import React, { Component } from 'react';
import {
  Loading,
  Button,
  Tabs,
  Tab,
  InlineNotification,
  TabsSkeleton,
  HeaderName,
  HeaderNavigation,
  SkeletonText,
} from 'carbon-components-react';
import { ChevronLeft16, Information16 } from '@carbon/icons-react';
import { ScrollingProvider, Section } from '../../lib/react-scroll-section/src/index';
import { Menu, Item } from '../../helpers/scrolling/ScrollingMenuItem';
import '../../scss/custom.scss';
import '../../scss/react-datetime.css';
import { switchDateFormat } from '../../helpers/jsonschemaform/customwidget/utils';
import { ComboBox } from '../../helpers/ComboBox';
import { showNotification } from '../../helpers/notification/BaseNotification';
import {
  getSuccess,
  getError,
  entitiesLabels,
  apioperation,
  STATUS,
} from '../../helpers/Constants';
import { api, dynamic, registry, me } from '../../helpers/api/api';
import ReportRepository from '../../helpers/api/ReportRepository';

import { IsInRole, IsEditable, CanExecuteAction } from '../../helpers/authorization/Policies';
import { AppContext } from '../../helpers/context/AppContext';
import {
  CheckmarkOutline16,
  Send16,
  Delete16,
  Error16,
  InformationFilled16,
} from '@carbon/icons-react/lib/';
import { WFActionModal } from '../common/WFActionModal';
import IncidentTabNotification from './IncidentTabNotification';
import IncidentTabReport from './IncidentTabReport';
import IncidentTabInvestigation from './IncidentTabInvestigation';
import IncidentTabCauses from './IncidentTabCauses';
import PageBreadCrumb from '../../helpers/PageBreadCrumb';
import { HistoryTable } from '../../helpers/HistoryTable';
import IncidentRepository from '../../helpers/api/IncidentRepository';
import { Online, Offline } from '../common/OnLineOffLine';
import moment from 'moment';

const initialState = {
  isEdit: false,
  isLoadingIncident: false,
  idIncidentEdit: undefined,
  incidentEditModel: null,
  isSubmitted: false,
  toSubmit: false,

  appActivity: [],
  appMatrixCell: null, //static matrix obj
  appMatrixColor: null, //static matrix obj
  appPublicAuthoritiesAndEntitiesInvolved: [],
  appTransportAccident: [],
  appInfoOriginator: [],
  subContractors: [],
  appWorkRelated: [],
  appPlace: [],
  appProbabilities: [],
  appSeveritiesInvestigation: [],
  appSeveritiesConsequences: [],
  appLifeSavingRuleCategory: [],
  appLifeSavingRule: [],
  appAllWorksites: null,
  appAllWorksitePrj: null,
  ///report///
  appCountry: [],
  appInjuryType: [],
  ///Status Action
  isApprovalModalOpen: false,
  approvalModalAction: '',
  approver: null,
  approvalStartDate: null,
  approvalEndDate: null,
  isLoadingApproverOptions: true,
  approvalValidationMessages: [],
  approvers: [],
  selectedData: [],
  approverRole: '',
  withApprover: true,
  isLoadingWFOperation: false,
  approvalNotesRequired: false,
  ///Status Action
  //History WF
  isHistoryModalOpen: false,
  //History WF
};

export default class NewIncidentReport extends Component {
    constructor(props) {
        super(props);

        this.selectTab = this.selectTab.bind(this);

        let idIncidentEdit = this.props.match.params.id;

        this.state = {
            stateIcon: false,
            stateTabs: 0,
            ...initialState,
            idIncidentEdit,
            isLoadingIncident: idIncidentEdit != undefined,
            isDisabledAll: false,
            isAutoOpenInjuredPerson: false,//RITM0864430
        };
    }
    baseUrl = '/incident/';
    componentDidMount() {
        this.getAllWorkSite();
        this.setStaticObject();
        this.getLifeSavingRule();
        this.getAllActivity();
        this.getCountry();
        this.getInjuryType();

        if (this.state.idIncidentEdit != undefined) {
            this.getIncidentForEdit(this.state.idIncidentEdit);
        } else {
            this.getAllWorkSitePrj('');
        }
    }

    showButtonHistory = () => {
        return (
            <Online>
                <Button
                    className="action-button-modal"
                    kind="secondary"
                    renderIcon={Information16}
                    onClick={() => this.openModalHistory()}
                >
                    History
        </Button>
            </Online>
        );
    };
    openModalHistory = () => {
        this.setState({ isHistoryModalOpen: true });
    };
    closeModalHistory = () => {
        this.setState({ isHistoryModalOpen: false });
    };
    selectTab(tabIndex) {
        this.setState({ stateTabs: tabIndex });
    }

    isSubmitted = (value) => {
        this.setState({ isSubmitted: value });
    };

    setlifeSavingRules = (value) => {
        if (this.state.incidentEditModel !== null
            & this.state.incidentEditModel !== undefined
            && this.state.incidentEditModel.tabNotifications !== null
            && this.state.incidentEditModel.tabNotifications !== undefined) {
            var obj = Object.assign(this.state.incidentEditModel.tabNotifications);
            obj['lifeSavingRules'] = value;

            this.setState((prevState) => ({
                toSubmit: false,
                incidentEditModel: {
                    ...prevState.incidentEditModel,
                    tabNotifications: obj,
                },
            }));
        }
    }

    showLoading() {
        let show = (this.state.isEdit && this.state.isLoadingIncident) || this.state.isSubmitted;
        let descr = this.state.isSubmitted ? 'Saving...' : 'Loading data...';
        return show && <Loading active={true} withOverlay={true} description={descr} />;
        //return (<InlineLoading className="bx--loading-overlay" {...props} />)
    }

    async getIncidentForEdit(id) {
        try {
            this.setState({
                isEdit: true,
                isLoadingIncident: true,
            });

            const response = await api.get(this.baseUrl, id);
            let data = response.data;
            if (data && data.tabNotifications && data.tabNotifications.id) {
                console.log('getIncidentForEdit(): data received!');
                this.setState({
                    idIncidentEdit: id,
                    incidentEditModel: data,
                });
                console.log('getIncidentForEdit(): data.tabNotifications.idProject: ' + data.tabNotifications.idProject);
                await this.getAllWorkSitePrj(data.tabNotifications.idProject);

            } else {
                showNotification.error();
                this.cancel();
            }
            console.log('getIncidentForEdit(): end of try');
        } catch(error) {
            showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INCIDENT, apioperation.GET));
            this.cancel();
        } finally {
            console.log('getIncidentForEdit(): finally');
            this.setState({ isLoadingIncident: false });
        }
    }

  getAllWorkSite() {
    api
      .getAll('/me/worksites')
      .then((response) => {
        var data = response.data;
        this.setState({
          appAllWorksites: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.WORKSITE, apioperation.GET)
        );
      })
      .finally(() => {});
  }

    async getAllWorkSitePrj(currentIdProject) {
        this.setState({
            isLoadingIncident: true
        });
      console.log('getAllWorkSitePrj(): currentIdProject: ' + currentIdProject);
    await api
        .getAll('/me/worksitesproject' + (currentIdProject != '' ? '?currentIdProject=' + currentIdProject : ''))
        .then((response) => {
            console.log('getAllWorkSitePrj(): response received!');
            var data = response.data;
            this.setState({
                appAllWorksitePrj: data
            });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.WORKSITEPROJECT, apioperation.GET)
        );
      })
        .finally(() => {
            console.log('getAllWorkSitePrj(): finally');
            this.setState(
                {
                    isLoadingIncident: false
                }
            );
        });
  }

  getCountry() {
    api
      .getAll('/country')
      .then((response) => {
        var data = response.data;
        this.setState({
          appCountry: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.COUNTRY, apioperation.GET)
        );
      })
      .finally(() => {});
  }

  getAllActivity() {
    api
      .getAll('/activity')
      .then((response) => {
        var data = response.data;
        this.setState({
          appActivity: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.ACTIVITY, apioperation.GET)
        );
      })
      .finally(() => {});
  }

  getLifeSavingRule = () => {
    dynamic
      .getAll('lifesavingrule', { params: { page: 0 } })
      .then((response) => {
        var data = response.data.itemList;
        this.setState({
          appLifeSavingRule: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
            getError(error, entitiesLabels.LIFESAVINGRULEVIOLATION, apioperation.GET)
        );
      })
      .finally(() => {});

    dynamic
      .getAll('lifesavingrulecategory', { params: { page: 0 } })
      .then((response) => {
        var data = response.data.itemList;
        this.setState({
          appLifeSavingRuleCategory: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
            getError(error, entitiesLabels.LIFESAVINGRULEVIOLATION, apioperation.GET)
        );
      })
      .finally(() => {});
  };

  getInjuryType = () => {
    dynamic
      .getAll('injurytype', { params: { page: 0 } })
      .then((response) => {
        var data = response.data.itemList;
        this.setState({
          appInjuryType: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.INJURYTYPE, apioperation.GET)
        );
      })
      .finally(() => {});
  };

  setStaticObject = () => {
    registry
      .getAll('publicauthorities')
      .then((response) => {
        var data = response.data;
        data =
          data != null
            ? data.map((item) => ({
                id: item.name,
                name: item.name,
                specifyOther: item.specifyOther,
              }))
            : [];
        data.sort(function (a, b) {
          return a.code - b.code;
        });
        this.setState({
          appPublicAuthoritiesAndEntitiesInvolved: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.PUBLICAUTHORITIES, apioperation.GET)
        );
      })
      .finally(() => {});

    // var appTransportAccident = [
    //     { id: 'No', text: 'No' },
    //     { id: 'AirTrasport', text: 'Air Trasport' },
    //     { id: 'RoadTraffic', text: 'Road Traffic' },
    //     { id: 'Ship/VesselTrasport', text: 'Ship/Vessel Trasport' },
    //     // { id: 'RollBar', text: 'Is the vehicle equipped with IVMS and Roll Bar' }
    // ];

    registry
      .getAll('transportaccident')
      .then((response) => {
        var data = response.data;
        data =
          data != null
            ? data.map((item) => ({
                id: item.name,
                text: item.name,
                specifyOther: item.specifyOther,
              }))
            : [];
        data.sort(function (a, b) {
          return a.code - b.code;
        });
        this.setState({
          appTransportAccident: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.TRANSPORTACCIDENT, apioperation.GET)
        );
      })
      .finally(() => {});

    registry
      .getAll('infooriginator')
      .then((response) => {
        var data = response.data;
        data = data != null ? data.map((item) => ({ id: item.name, name: item.name })) : [];
        this.setState({
          appInfoOriginator: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.INFOORIGINATOR, apioperation.GET)
        );
      })
      .finally(() => {});

    ReportRepository.getSubcontractors()
      .then((response) => {
        this.setState({
          subContractors: response,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.SUBCONTRACTOR, apioperation.get)
        );
      })
      .finally(() => {
        this.setState({
          isLoadingSubContractorOptions: false,
        });
      });

    // var appWorkRelated = [
    //     { id: 'Yes', text: 'Yes' },
    //     { id: 'No', text: 'No' },
    //     { id: 'Communting', text: 'Communting', },
    // ];

    registry
      .getAll('workrelated')
      .then((response) => {
        var data = response.data;
        data =
          data != null
            ? data.map((item) => ({
                id: item.name,
                text: item.name,
                specifyOther: item.specifyOther,
              }))
            : [];
        data.sort(function (a, b) {
          return a.code - b.code;
        });
        this.setState({
          appWorkRelated: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.WORKRELATED, apioperation.GET)
        );
      })
      .finally(() => {});

    // var appPlace = [
    //     { id: 'CampConstructionSite', text: 'Camp to Construction Site / viceversa' },
    //     { id: 'ResidenceplaceWorkplace', text: 'Residence place to Workplace / viceversa' },
    // ];

    dynamic
      .getAll('place', { params: { page: 0 } })
      .then((response) => {
        var data = response.data.itemList;
        data = data != null ? data.map((item) => ({ id: item.name, text: item.name })) : [];

        this.setState({
          appPlace: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.PLACE, apioperation.GET)
        );
      })
      .finally(() => {});

    dynamic
      .getAll('probability', { params: { page: 0 } })
      .then((response) => {
        let appProbabilities = response.data.itemList;
        appProbabilities.sort(function (a, b) {
          return a.code - b.code;
        });

        this.setState({
          appProbabilities,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.PROBABILITY, apioperation.GET)
        );
      })
      .finally(() => {});

    dynamic
      .getAll('severity', { params: { page: 0 } })
      .then((response) => {
        let appSeverities = response.data.itemList;
        let appSeveritiesInvestigation = appSeverities.filter((el) => el.revision == 2);
        appSeveritiesInvestigation.sort((a, b) => a.code - b.code);
        let appSeveritiesConsequences = appSeverities.filter((el) => el.revision == 1);
        appSeveritiesConsequences.sort((a, b) => a.code - b.code);
        this.setState({
          appSeveritiesInvestigation,
          appSeveritiesConsequences,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.SEVERITY, apioperation.GET)
        );
      })
      .finally(() => {});

    var appMatrixCell = {
      1: { lvlReal: 'A', lvlPot: { 1: 'A', 2: 'A', 3: 'A', 4: 'A', 5: 'B' } },
      2: { lvlReal: 'A', lvlPot: { 1: 'A', 2: 'A', 3: 'A', 4: 'B', 5: 'B' } },
      3: { lvlReal: 'B', lvlPot: { 1: 'A', 2: 'A', 3: 'B', 4: 'B', 5: 'C' } },
      4: { lvlReal: 'C', lvlPot: { 1: 'B', 2: 'B', 3: 'B', 4: 'C', 5: 'C' } },
      5: { lvlReal: 'C', lvlPot: { 1: 'B', 2: 'B', 3: 'C', 4: 'C', 5: 'C' } },
    };

    var appMatrixColor = {
      A: 'rgb(144, 238, 144, 0.6)', //verde
      B: 'rgb(255, 255, 0, 0.6)', //giallo
      C: 'rgb(255, 69, 0, 0.6)', //rosso
    };

    this.setState({ appMatrixCell, appMatrixColor });
  };

  cancel = () => {
    this.props.history.push('/incident');
  };

  updateType = (dati) => {
    this.setState((prevState) => ({
      incidentEditModel: {
        ...prevState.incidentEditModel,
        tabNotifications: dati,
      },
    }));
  };

  updateCacheIncidentModel = async (datiForm, tab) => {
    if (tab == 'tabNotifications') {
      //aggiorno la lista degli incident quando viene modificato il tab notification
      var dati = datiForm;

      var result = [];
      if (dati.outcomeAsset != null && dati.outcomeAsset == true) result.push('Property/Asset');
      if (dati.outcomeEnvironmental != null && dati.outcomeEnvironmental == true)
        result.push('Environmental');
      if (dati.outcomeHarm != null && dati.outcomeHarm == true) result.push('Harm To People');

      var incidentDTO = {
        id: dati.id,
        idStatus: dati.idStatus,
        status: dati.status.reportingName,
        investigationLevel: dati.investigationLevel,
        incidentReportId: null,
        idDivision: dati.idDivision,
        division: dati.division,
        idWorksite: dati.idWorksite,
        worksite: (this.state.appAllWorksites || []).find((el) => el.id == dati.idWorksite)?.name,
        title: dati.title,
        occurrenceDate: moment.utc(dati.occurrenceDate).format('YYYY-MM-DD'),
        type: dati.type,
        outcomeAsset: dati.outcomeAsset,
        outcomeEnvironmental: dati.outcomeEnvironmental,
        outcomeHarm: dati.outcomeHarm,
        realOutcomeAsset: dati.realOutcomeAsset,
        realOutcomeEnvironmental: dati.realOutcomeEnvironmental,
        realOutcomeHarm: dati.realOutcomeHarm,
        outcome: result.join(','),
        idCompiler: dati.idCompiler,
        idDataApprover: dati.idDataApprover,
        idDivisionManager: dati.idDivisionManager,
      };

      if (!this.state.isEdit) {
        //in creazione inizializzo il modello per tutti i tab
        let statusCopy = {};

        statusCopy['tabNotifications'] = datiForm;

        statusCopy['tabReport'] = {
          noInjured: null,
          injuredPeople: [],
          eventCause: null,
          actions: null,
          dueDate: null,
          id: dati.id,
          progressiveId: undefined,
          incidentReportId: null,
          idStatus: dati.idStatus,
          status: dati.status,
          idCompiler: dati.idCompiler,
          idDataApprover: null,
          idDivisionManager: null,
        };

        statusCopy['tabInvestigation'] = {
          sourceAccident: null,
          spillLakeUM: null,
          spillLakeNumericValue: null,
          spillRiverUM: null,
          spillRiverNumericValue: null,
          spillSeaUM: null,
          spillSeaNumericValue: null,
          spillSoilUM: null,
          spillSoilNumericValue: null,
          spillSubstanceReleased: null,
          spillDescription: null,
          isUsedSpillKit: null,
          isInPlaceProcedure: null,
          airPollUM: null,
          airPollSubstanceReleased: null,
          airPollQuantityReleased: null,
          isFloraImpacted: null,
          isFaunaImpacted: null,
          incidentEvents: [],
          idWorkAreaType: null,
          idWorkProcessType: null,
          idEquipmentType: null,
          idWorkArea: null,
          idWorkProcess: null,
          idEquipment: null,
          light: null,
          lightOrigin: null,
          wheather: null,
          sea: null,
          temperature: null,
          temperatureType: null,
          windSpeed: null,
          noWitness: null,
          witnessPeople: [],
          investigationTeamMembers: [],
          attachment: [],
          id: dati.id,
          progressiveId: undefined,
          incidentReportId: null,
          idStatus: dati.idStatus,
          status: dati.status,
          idCompiler: dati.idCompiler,
          idDataApprover: null,
          idDivisionManager: null,
        };

        statusCopy['tabCauses'] = {
          investigationCriticalFactors: null,
          returnOfExperience: null,
          incidentCAR: [],
          id: dati.id,
          progressiveId: undefined,
          incidentReportId: null,
          idStatus: dati.idStatus,
          status: dati.status,
          idCompiler: dati.idCompiler,
          idDataApprover: null,
          idDivisionManager: null,
        };

        let carListModel = {
          id: datiForm.id,
          incidentCode: null,
          incident: {
            id: datiForm.id,
            progressiveId: undefined,
            incidentReportId: null,
            idStatus: dati.idStatus,
            status: dati.status,
            idCompiler: dati.idCompiler,
            idDataApprover: null,
            idDivisionManager: null,
          },
          incidentCAR: [],
        };

        await Promise.all([
          IncidentRepository.updateCachedIncidentList(incidentDTO),
          IncidentRepository.updateCachedIncident(datiForm.id, statusCopy, tab),
        ])
          .then((response) => {
            if(!this.state.isAutoOpenInjuredPerson){
            this.props.history.push('/incident/');
          }
          })
          .catch((error) => {
            console.error({ error });
          })
          .finally(() => {
            IncidentRepository.createCachedIncidentCAR(datiForm.id, carListModel);
          });
      } else {
        let statusCopy = Object.assign(this.state.incidentEditModel);
        statusCopy['tabNotifications'] = datiForm;
        console.log(statusCopy)
        this.setState({
          incidentEditModel: statusCopy
        }, () => {
          IncidentRepository.updateCachedIncidentList(incidentDTO);
          IncidentRepository.updateCachedIncident(datiForm.id, datiForm, tab);
        })        
      }
    } else {
      IncidentRepository.updateCachedIncident(datiForm.id, datiForm, tab);
    }
  };

  ///Status Action
  handleApproverSelect = (selectedItem) => {
    this.setState({ approver: selectedItem });
  };

  handleCloseApprovalModal = () => {
    this.setState({ isApprovalModalOpen: false }, this.clearApprovalForm);
  };

  handleApprovalNotesChange = (e) => {
    this.setState({ approvalNotes: e.target.value });
  };

  handleConfirmApprovalModal = () => {
    let action = this.state.approvalModalAction.toLowerCase();
    let apiEndpoint = this.state.approvalEndpoint;

    const data = {
      ids: [this.state.idIncidentEdit],
      owner: this.state.approver,
      workflowNotes: this.state.approvalNotes,
    };

    this.setState({
      isLoadingWFOperation: true,
    });
    api
      .put(this.baseUrl + apiEndpoint, data, '')
      .then((response) => {
        if (response.status === 200) {
          showNotification.success(
            `${entitiesLabels.SUCCESS}`,
            getSuccess(entitiesLabels.INCIDENT, apioperation.PUT)
          );
          this.setState({
            isLoadingWFOperation: false,
            isApprovalModalOpen: false,
            isLoading: true,
            // model: null
          });
          this.props.history.push('/incident');
          //this.getIncidentForEdit(this.state.idIncidentEdit);
        } else {
          showNotification.error();
          this.setState({
            isLoadingWFOperation: false,
          });
        }
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.INCIDENT, apioperation.PUT)
        );
        this.setState({
          isLoadingWFOperation: false,
        });
      })
      .finally(() => {});
  };

  IsRowSelectable() {
    var row = this.state.incidentEditModel;
    if (
      row == null ||
      row.tabNotifications == null ||
      row.tabNotifications.idStatus == STATUS.Consolidated
    )
      return false;

    return true;
  }

  batchActionClick(
    actionKey,
    actionName,
    approverRole,
    withApprover,
    approvalNotesRequired,
    selectedRows
  ) {
    var incident = this.state.incidentEditModel.tabNotifications;

    if(actionKey == 'Submit' && (incident.lifeSavingRules === null || incident.lifeSavingRules?.length <= 0)) {
      this.setState({
        toSubmit: true
      })

      showNotification.warning(
        `${entitiesLabels.WARNING}`,
        entitiesLabels.INCIDENT + ' required fields are missing  '
      );

      return;    
    }


    var idEntity =
      actionKey == 'Submit'
        ? incident.idWorksite
        : actionKey == 'Approve'
        ? incident.idDivision
        : null;

    this.setState({
      toSubmit: false,
      approvalModalAction: actionName,
      isApprovalModalOpen: true,
      isLoadingApproverOptions: true,
      withApprover: withApprover,
      selectedData: selectedRows,
      approverRole: approverRole,
      approvalEndpoint: actionKey,
      approvalNotesRequired: approvalNotesRequired,
    });

    if (withApprover) this.getUsersInRole(approverRole, idEntity);
  }

  getUsersInRole = (role, idEntity) => {
    me.getWithParam('users', {
      params: { Role: role, IdEntity: idEntity, includeAdmins: true },
    })
      .then((response) => {
        this.setState({
          approvers: response.data,
          isLoadingApproverOptions: false,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.ROLE, apioperation.GET)
        );
      })
      .finally(() => {
        this.setState({
          isLoadingApproverOptions: false,
        });
      });
  };

  getStatusActions = (user) => {
    if (!this.IsRowSelectable()) return null;

    const idStatus = this.state.incidentEditModel.tabNotifications.idStatus;
    return (
      <Online>
        {CanExecuteAction(
          'Incident',
          'Reporting',
          user,
          idStatus,
          'Submit',
          this.state.incidentEditModel.tabNotifications
        ) ? (
          <Button
            renderIcon={Send16}
            onClick={() =>
              this.batchActionClick('Submit', 'Submit', 'Data Approver', true, false, null)
            }
          >
            Submit Report
          </Button>
        ) : null}

        {CanExecuteAction(
          'Incident',
          'Reporting',
          user,
          idStatus,
          'Approve',
          this.state.incidentEditModel.tabNotifications
        ) ? (
          <Button
            renderIcon={CheckmarkOutline16}
            onClick={() =>
              this.batchActionClick('Approve', 'Approve', 'Division Manager', true, false, null)
            }
          >
            Approve Report
          </Button>
        ) : null}

        {CanExecuteAction(
          'Incident',
          'Reporting',
          user,
          idStatus,
          'Consolidate',
          this.state.incidentEditModel.tabNotifications
        ) ? (
          <Button
            renderIcon={CheckmarkOutline16}
            onClick={() =>
              this.batchActionClick('Consolidate', 'Approve', null, false, false, null)
            }
          >
            Consolidate Report
          </Button>
        ) : null}

        {CanExecuteAction(
          'Incident',
          'Reporting',
          user,
          idStatus,
          'Reject',
          this.state.incidentEditModel.tabNotifications
        ) ? (
          <Button
            renderIcon={Error16}
            onClick={() => this.batchActionClick('Reject', 'Reject', null, false, true, null)}
          >
            Reject Report
          </Button>
        ) : null}

        {CanExecuteAction(
          'Incident',
          'Reporting',
          user,
          idStatus,
          'RejectConsolidate',
          this.state.incidentEditModel.tabNotifications
        ) ? (
          <Button
            renderIcon={Error16}
            onClick={() =>
              this.batchActionClick('RejectConsolidate', 'Reject', null, false, true, null)
            }
          >
            Reject Report
          </Button>
        ) : null}

        {CanExecuteAction(
          'Incident',
          'Reporting',
          user,
          idStatus,
          'Delete',
          this.state.incidentEditModel.tabNotifications
        ) ? (
          <Button
            renderIcon={Delete16}
            onClick={() => this.batchActionClick('Delete', 'Delete', null, false, false, null)}
          >
            Delete
          </Button>
        ) : null}
      </Online>
    );
  };
  ///Fine Status Action

  handleNotificationChange = (outcomeAsset, outcomeEnvironmental, outcomeHarm, realOutcomeHarm) => {
    this.setState((prevState) => ({
      ...prevState,
      outcomeEnvironmental: outcomeEnvironmental,
      outcomeAsset: outcomeAsset,
      outcomeHarm: outcomeHarm,
      realOutcomeHarm: realOutcomeHarm,
    }));
  };

  //RITM0864430
  updateAutoOpenInjuredPerson = (value) => {
    this.setState({isAutoOpenInjuredPerson: value });
};

updateHarmedPeople = (value) => {
  this.getIncidentForEdit(this.state.idIncidentEdit);
};

  
  updateEditMode = (value) => {
    this.setState({idIncidentEdit: value });
    this.getIncidentForEdit(this.state.idIncidentEdit);
};

    render() {

     const currentProject= {
      idProject:this.state.incidentEditModel?.tabNotifications.idProject ||'',
      idWorkSite:this.state.incidentEditModel?.tabNotifications.idWorksite||'',
      project: this.state.incidentEditModel?.tabNotifications.project||[]
    
    };

    // console.log ("===>", currentProject)
    let  appAllWorksitePrj=[];
    if (this.state.appAllWorksitePrj){
       appAllWorksitePrj=  this.state.appAllWorksitePrj?.find(el=>el.idProject===currentProject.id) ? this.state.appAllWorksitePrj : [...this.state.appAllWorksitePrj,currentProject];  
      }
        



    const tabNotificationProps = {
      key: 'tabNotif' + (this.state.incidentEditModel ? 'Edit' : 'Add'),
      isEdit: this.state.isEdit,
      toSubmit: this.state.toSubmit,
      incidentEditModel:
        this.state.incidentEditModel && this.state.incidentEditModel.tabNotifications,
      isLoadingIncident: this.state.isLoadingIncident,
      appActivity: this.state.appActivity || [],
      appMatrixCell: this.state.appMatrixCell,
      appMatrixColor: this.state.appMatrixColor,
      appPublicAuthoritiesAndEntitiesInvolved:
        this.state.appPublicAuthoritiesAndEntitiesInvolved || [],
      appTransportAccident: this.state.appTransportAccident || [],
      appInfoOriginator: this.state.appInfoOriginator || [],
      subContractors: this.state.subContractors || [],
      appWorkRelated: this.state.appWorkRelated || [],
      appPlace: this.state.appPlace || [],
      appProbabilities: this.state.appProbabilities || [],
      appSeveritiesInvestigation: this.state.appSeveritiesInvestigation || [],
      appSeveritiesConsequences: this.state.appSeveritiesConsequences || [],
      appLifeSavingRuleCategory: this.state.appLifeSavingRuleCategory || [],
      appLifeSavingRule: this.state.appLifeSavingRule || [],
      appAllWorksites: this.state.appAllWorksites,
	  appAllWorksitePrj: appAllWorksitePrj,
      selectTab: this.selectTab,
      isSubmitted: this.isSubmitted,
      setlifeSavingRules: this.setlifeSavingRules,
      history: this.props.history,
      cancel: this.cancel,
      updateType: this.updateType,
      updateCacheIncidentModel: this.updateCacheIncidentModel,
      onChange: this.handleNotificationChange,
      autoInjuredPersonModal: this.state.isAutoOpenInjuredPerson,//RITM0864430
      updateAutoOpenInjuredPerson: this.updateAutoOpenInjuredPerson,//RITM0864430
      updateEditMode: this.updateEditMode,
      updateHarmedPeople: this.updateHarmedPeople,
    };

    const tabReportProps = {
      key: 'tabReport' + (this.state.incidentEditModel ? 'Edit' : 'Add'),
      incidentEditModel: this.state.incidentEditModel && this.state.incidentEditModel.tabReport,
      isLoadingIncident: this.state.isLoadingIncident,
      appInjuryType: this.state.appInjuryType || [],
      appCountry: this.state.appCountry || [],
      appType: this.state.appInfoOriginator || [],
      selectTab: this.selectTab,
      isSubmitted: this.isSubmitted,
      history: this.props.history,
      cancel: this.cancel,
      submitReport: () =>
        this.batchActionClick('Submit', 'Submit', 'Data Approver', true, false, null),
      updateCacheIncidentModel: this.updateCacheIncidentModel,
      isDisabled: this.state.isDisabledAll || false,
      isAccident:
        this.state.incidentEditModel && this.state.incidentEditModel.tabNotifications
          ? this.state.incidentEditModel.tabNotifications.realOutcomeHarm == true
          : false,
    };

    const tabInvestigationProps = {
      key: 'tabInvestigation' + (this.state.incidentEditModel ? 'Edit' : 'Add'),
      incidentEditModel:
        this.state.incidentEditModel && this.state.incidentEditModel.tabInvestigation,
      noInjuredPerson:
        this.state.incidentEditModel?.tabInvestigation?.noInjured != null
          ? this.state.incidentEditModel?.tabInvestigation?.noInjured
          : this.state.incidentEditModel?.tabNotifications?.realOutcomeHarm,
      isLoadingIncident: this.state.isLoadingIncident,
      appType: this.state.appInfoOriginator || [],
      subContractors: this.state.subContractors || [],
      appInjuryType: this.state.appInjuryType || [],
      appCountry: this.state.appCountry || [],
      outcomeEnviroment:
        this.state.outcomeEnvironmental !== undefined
          ? this.state.outcomeEnvironmental
          : this.state.incidentEditModel?.tabNotifications?.outcomeEnvironmental
          ? true
          : false,
      outcomeAsset:
        this.state.outcomeAsset !== undefined
          ? this.state.outcomeAsset
          : this.state.incidentEditModel?.tabNotifications?.outcomeAsset
          ? true
          : false,
      outcomeHarm:
        this.state.outcomeHarm !== undefined
          ? this.state.outcomeHarm
          : this.state.incidentEditModel?.tabNotifications?.outcomeHarm
          ? true
          : false,
      realOutcomeHarm:
        this.state.realOutcomeHarm !== undefined
          ? this.state.realOutcomeHarm
          : this.state.incidentEditModel?.tabNotifications?.realOutcomeHarm
          ? true
          : false,
      selectTab: this.selectTab,
      isSubmitted: this.isSubmitted,
      history: this.props.history,
      cancel: this.cancel,
      updateCacheIncidentModel: this.updateCacheIncidentModel,
      isDisabled: this.state.isDisabledAll || false,
      autoInjuredPersonModal: this.state.isAutoOpenInjuredPerson,//RITM0864430
      updateAutoOpenInjuredPerson: this.updateAutoOpenInjuredPerson,
      updateHarmedPeople: this.updateHarmedPeople,
    };

    const tabCausesProps = {
      key: 'tabCauses' + (this.state.incidentEditModel ? 'Edit' : 'Add'),
      incidentEditModel: this.state.incidentEditModel && this.state.incidentEditModel.tabCauses,
      isLoadingIncident: this.state.isLoadingIncident,
      selectTab: this.selectTab,
      isSubmitted: this.isSubmitted,
      history: this.props.history,
      cancel: this.cancel,
      updateCacheIncidentModel: this.updateCacheIncidentModel,
      isDisabled: this.state.isDisabledAll || false,
    };
   
    return (
      <AppContext.Consumer>
        {({ user }) => (
          <>
            <PageBreadCrumb
              linkTo={!this.state.isEdit ? '/incident' : '/incident?isBack'}
              linkText="Incidents"
              titleLeft={this.state.isEdit ? 'Edit Incident' : 'New Incident'}
              titleCenter={
                this.state.incidentEditModel &&
                'ID: ' + this.state.incidentEditModel.tabNotifications.incidentReportId
              }
              titleRight={
                this.state.incidentEditModel && this.state.incidentEditModel.tabNotifications.status
                  ? this.state.incidentEditModel.tabNotifications.status.reportingName
                  : null
              }
              batchActions={this.getStatusActions(user)}
              showButtonHistory={this.state.isEdit ? this.showButtonHistory() : null}
            />
            <div className="mainContainer">
                  
              {/* RITM0655780 */}
              { !(this.state.incidentEditModel 
                && this.state.incidentEditModel.tabNotifications 
                && this.state.incidentEditModel.tabNotifications.notificationDate 
                && this.state.incidentEditModel.tabNotifications.notificationDate.startsWith('0001-01-01')
              ) ? (
                ''
              ) : this.state.isLoadingIncident ? (
                <div className="bx--col-lg-12 bx--tab-container">
                  <TabsSkeleton className="bannerNotification" />
                </div>
              ) : (
                <div className="bx--row">
                  <InlineNotification
                    kind={'warning'}
                    lowContrast={true}
                    title={'Warning'}
                    subtitle={'The Incident Notification has not been sent!'}
                    iconDescription=""
                    hideCloseButton="true"
                    style={{ maxWidth: 'none' }}
                  />
                </div>
              )}
              {/* END RITM0655780 */}

              <div className="bx--grid content full-width">
                {this.showLoading()}
                <WFActionModal
                  show={this.state.isApprovalModalOpen}
                  title={`${this.state.approvalModalAction} Incidents`}
                  action={this.state.approvalModalAction}
                  withApprover={this.state.withApprover}
                  approver={this.state.approver}
                  approverRole={this.state.approverRole}
                  approverOptions={this.state.approvers}
                  isLoadingOperation={this.state.isLoadingWFOperation}
                  onApproverSelect={this.handleApproverSelect}
                  isLoadingOptions={this.state.isLoadingApproverOptions}
                  onCancel={this.handleCloseApprovalModal}
                  onConfirm={this.handleConfirmApprovalModal}
                  onApprovalNotesChange={this.handleApprovalNotesChange}
                  approvalNotes={this.state.approvalNotes}
                  approvalNotesRequired={this.state.approvalNotesRequired}
                  validationMessages={this.state.approvalValidationMessages}
                />
                {this.state.isEdit ? (
                  <HistoryTable
                    entityId={this.state.idIncidentEdit}
                    isOpenModal={this.state.isHistoryModalOpen}
                    onClose={() => this.closeModalHistory()}
                  />
                ) : (
                  ''
                )}
                <form
                  autoComplete="off"
                  onSubmit={(e) => {
                    e.preventDefault();
                  }}
                >
                  <div className=" bx--row">
                    <div className="bx--col-lg-12 bx--tab-container bx--tab--conteiner-incident">
                      <Tabs
                        selected={this.state.stateTabs}
                        onSelectionChange={(index) => this.setState({ stateTabs: index })}
                        tabContentClassName="tab-content"
                      >
                        <Tab key="tab_0" disabled={false} label="1.Notification" tabIndex={0}>
                          <ScrollingProvider key="scroll_0">
                            <IncidentTabNotification {...tabNotificationProps} user={user} />
                          </ScrollingProvider>
                        </Tab>
                        <Tab
                          key="tab_1"
                          disabled={!this.state.isEdit || (this.state.incidentEditModel 
                            && this.state.incidentEditModel.tabNotifications 
                            && this.state.incidentEditModel.tabNotifications.notificationDate 
                            && this.state.incidentEditModel.tabNotifications.notificationDate.startsWith('0001-01-01')
                          )}
                          label="2.Investigation"
                          tabIndex={2}
                        >
                          <ScrollingProvider>
                            {this.state.isEdit && this.state.incidentEditModel && (
                              <IncidentTabInvestigation {...tabInvestigationProps} user={user} />
                            )}
                          </ScrollingProvider>
                        </Tab>
                        <Tab
                          key="tab_2"
                          disabled={!this.state.isEdit || (this.state.incidentEditModel 
                            && this.state.incidentEditModel.tabNotifications 
                            && this.state.incidentEditModel.tabNotifications.notificationDate 
                            && this.state.incidentEditModel.tabNotifications.notificationDate.startsWith('0001-01-01')
                          )}
                          label="3.Causes"
                          tabIndex={3}
                        >
                          <ScrollingProvider>
                            {this.state.isEdit && this.state.incidentEditModel && (
                              <IncidentTabCauses {...tabCausesProps} user={user} />
                            )}
                          </ScrollingProvider>
                        </Tab>
                        <Tab
                          key="tab_3"
                          disabled={!this.state.isEdit || (this.state.incidentEditModel 
                            && this.state.incidentEditModel.tabNotifications 
                            && this.state.incidentEditModel.tabNotifications.notificationDate 
                            && this.state.incidentEditModel.tabNotifications.notificationDate.startsWith('0001-01-01')
                          )}
                          label="4.Report distribution"
                          tabIndex={1}
                        >
                          <ScrollingProvider>
                            {this.state.isEdit && this.state.incidentEditModel && (
                              <IncidentTabReport {...tabReportProps} user={user} />
                            )}
                          </ScrollingProvider>
                        </Tab>
                      </Tabs>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </>
        )}
      </AppContext.Consumer>
    );
  }
}
